import React, {
  useEffect,
  useState,
} from "react";

import {
  Check,
  X,
} from "@phosphor-icons/react";
import { toast } from "sonner";


export default function StockMovementModal({
  open,
  mode = "receive",
  part = null,
  saving = false,
  onClose,
  onSubmit,
}) {
  const [quantity, setQuantity] =
    useState("");

  const [note, setNote] =
    useState("");


  useEffect(() => {
    if (!open) {
      return;
    }

    setQuantity(
      mode === "adjust"
        ? String(
            part?.quantityOnHand ??
            0
          )
        : ""
    );

    setNote("");
  }, [
    open,
    mode,
    part,
  ]);


  if (
    !open ||
    !part
  ) {
    return null;
  }


  const submit = (
    event
  ) => {
    event.preventDefault();

    const numericQuantity =
      Number(quantity);

    if (
      Number.isNaN(
        numericQuantity
      ) ||
      numericQuantity < 0
    ) {
      toast.error(
        "La quantité est invalide."
      );

      return;
    }

    if (
      mode === "receive" &&
      numericQuantity <= 0
    ) {
      toast.error(
        "La quantité reçue doit être supérieure à zéro."
      );

      return;
    }

    if (
      mode === "adjust" &&
      !note.trim()
    ) {
      toast.error(
        "Le motif de correction est obligatoire."
      );

      return;
    }

    onSubmit(
      mode === "receive"
        ? {
            quantity:
              numericQuantity,
            note:
              note.trim(),
          }
        : {
            quantity_on_hand:
              numericQuantity,
            note:
              note.trim(),
          }
    );
  };


  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center acta-modal-overlay p-3 backdrop-blur-sm sm:p-6"
      data-testid="stock-movement-modal"
      onMouseDown={onClose}
    >
      <div
        className="acta-modal-surface w-full max-w-xl rounded-2xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] shadow-2xl"
        onMouseDown={(event) =>
          event.stopPropagation()
        }
      >
        <div className="flex items-center justify-between border-b border-[var(--do-border)] px-5 py-4">
          <div>
            <div className="label-eyebrow">
              {part.reference}
            </div>

            <h2 className="mt-1 font-heading text-xl font-black">
              {mode === "receive"
                ? "Réception de stock"
                : "Correction d’inventaire"}
            </h2>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            aria-label="Fermer"
            data-testid="stock-movement-close"
            className="rounded-lg p-2 hover:bg-[var(--do-surface-soft)]"
          >
            <X size={20} />
          </button>
        </div>

        <form
          onSubmit={submit}
          className="space-y-5 p-5"
        >
          <div className="rounded-xl border border-[var(--do-border)] bg-[var(--do-surface-soft)] p-4">
            <div className="text-sm font-heading font-bold">
              {part.name}
            </div>

            <div className="mt-1 text-xs text-[var(--do-muted)]">
              Stock actuel :{" "}
              <strong>
                {part.quantityOnHand}
              </strong>
            </div>
          </div>

          <div>
            <label
              htmlFor="stock-movement-quantity"
              className="label-eyebrow mb-1.5 block"
            >
              {mode === "receive"
                ? "Quantité reçue"
                : "Nouveau stock réel"}
            </label>

            <input
              id="stock-movement-quantity"
              type="number"
              min="0"
              step="0.01"
              value={quantity}
              onChange={(event) =>
                setQuantity(
                  event.target.value
                )
              }
              disabled={saving}
              autoFocus
              data-testid="stock-movement-quantity"
              className="w-full rounded-lg border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-3 py-2 text-sm"
            />
          </div>

          <div>
            <label
              htmlFor="stock-movement-note"
              className="label-eyebrow mb-1.5 block"
            >
              {mode === "adjust"
                ? "Motif obligatoire"
                : "Note"}
            </label>

            <textarea
              id="stock-movement-note"
              value={note}
              onChange={(event) =>
                setNote(
                  event.target.value
                )
              }
              disabled={saving}
              rows={4}
              maxLength={1000}
              data-testid="stock-movement-note"
              className="w-full resize-y rounded-lg border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-3 py-2 text-sm"
            />
          </div>

          <div className="flex flex-col-reverse gap-2 border-t border-[var(--do-border)] pt-4 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              disabled={saving}
              className="rounded-lg border border-[var(--do-border)] px-4 py-2 text-sm font-heading font-semibold"
            >
              Annuler
            </button>

            <button
              type="submit"
              disabled={saving}
              data-testid="stock-movement-submit"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-[var(--do-accent)] px-4 py-2 text-sm font-heading font-bold text-[var(--do-on-accent)] disabled:opacity-50"
            >
              <Check
                size={17}
                weight="bold"
              />

              {saving
                ? "Enregistrement…"
                : mode === "receive"
                  ? "Enregistrer la réception"
                  : "Corriger le stock"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
